module.exports = __webpack_public_path__ + "img/tw.tw8ea0b61.svg";